import { ITimelineOrder } from '../models/timeline.models';

/**
 * Customer-name values that really mean "no customer associated".
 *
 * The backend sends `N/A` for an unassociated customer rather than omitting the
 * field, so a truthiness check alone would read those orders as complete.
 */
const MISSING_CUSTOMER_VALUES = new Set(['n/a', 'na', '-', '--']);

export function isMissingCustomerValue(value: string | null | undefined): boolean {
  const name = value?.trim();
  return !name || MISSING_CUSTOMER_VALUES.has(name.toLowerCase());
}

/** ISO code prefixing a total, e.g. `EUR 336,94`. Empty when the order has none. */
export function orderCurrencyCode(order: ITimelineOrder['order'] | undefined): string {
  return order?.currency?.name ?? '';
}

/** Symbol suffixing an amount. Both timeline cards default to euro alike. */
export function orderCurrencySymbol(order: ITimelineOrder['order'] | undefined): string {
  return order?.currency?.symbol ?? '€';
}
